import { useState, useRef } from 'react';
const useAgentFile = () => {
    const [agentFile, changeAgentFile] = useState([]); //智能体附件列表
    const agentFileRef = useRef([]);
    const setAgentFile = (data) => {
        changeAgentFile(data);
        agentFileRef.current = data;
    };
    return {
        agentFile,
        setAgentFile,
        agentFileRef
    };
};
export default useAgentFile;
